import { Input, InputNumber } from "antd";
import Delete from "../../assets/Delete";

const columns = (handleAction) => [
  {
    title: "Title",
    dataIndex: "title",
    render: (_, record) => (
      <Input
        value={record?.title}
        status={record?.errors?.title ? "error" : ""}
        onChange={(e) =>
          handleAction("edit", record, { title: e?.target?.value })
        }
      />
    ),
  },
  {
    title: "Description",
    dataIndex: "description",
    render: (_, record) => (
      <Input
        value={record?.description}
        status={record?.errors?.description ? "error" : ""}
        onChange={(e) =>
          handleAction("edit", record, { description: e?.target?.value })
        }
      />
    ),
  },
  {
    title: "Unit",
    dataIndex: "unit",
    render: (_, record) => (
      <InputNumber
        min={1}
        value={record?.unit}
        status={record?.errors?.unit ? "error" : ""}
        onChange={(value) =>
          handleAction("edit", record, {
            unit: value,
            charge: (value || 0) * (record?.amount || 0),
          })
        }
      />
    ),
  },
  {
    title: "Charge",
    dataIndex: "amount",
    render: (_, record) => (
      <InputNumber
        min={0}
        value={record?.amount}
        status={record?.errors?.amount ? "error" : ""}
        onChange={(value) =>
          handleAction("edit", record, {
            amount: value,
            charge: (record?.unit || 0) * (value || 0),
          })
        }
      />
    ),
  },
  {
    title: "Total",
    dataIndex: "charge",
    render: (_, record) => (record?.unit || 0) * (record?.amount || 0),
  },
  {
    title: "Action",
    dataIndex: "action",
    render: (_, record) => (
      <button type="button" onClick={() => handleAction("delete", record)}>
        <Delete />
      </button>
    ),
  },
];

export default columns;
